/**
 * {CheckoutConditionalNavigation}
 * @param {window} $window
 * @param {PageRequirements} pageRequirements
 * @param {String} defaultPage
 * @constructor
 */
var CheckoutConditionalNavigation = function ($window,
                                              pageRequirements,
                                              defaultPage) {
    let self = this;

    /**
     * getQuery string
     * @returns {string}
     */
    this.getQuery = function () {
        let query = $window.location.search;
        let hash = $window.location.hash;
        let hashQuery = '';
        let hashes = hash.split('?');
        if (hashes.length > 1) {
            if (query) {
                hashQuery = '&' + hashes[1];
            } else {
                hashQuery = '?' + hashes[1];
            }
        }

        return query + hashQuery;
    };

    /**
     * getHash
     * @returns {*}
     */
    this.getHash = function () {
        let hash = $window.location.hash;
        let hashes = hash.split('?');
        return hashes[0];
    };

    /**
     * getCurrentPage
     * @returns {*}
     */
    this.getCurrentPage = function () {
        return $window.location.pathname + self.getHash();
    };

    /**
     * defaultPage
     */
    this.defaultPage = function () {
        let defaultPage = self.getDefaultPage();

        self.navigate(defaultPage);
    };

    /**
     * getDefaultPage
     * @returns {String}
     */
    this.getDefaultPage = function () {
        return defaultPage;
    };

    /**
     * nextPage
     * @param conditions
     */
    this.nextPage = function (conditions) {
        self.navigate(self.getNextPage(conditions));
    };

    /**
     * getNextPage
     * @returns {string}
     */
    this.getNextPage = function (conditions) {
        const requiredPage = self.getNextRequiredPage(pageRequirements.finalPage, conditions);

        if (requiredPage) {
            return requiredPage + self.getQuery();
        }

        return pageRequirements.finalPage + self.getQuery();
    };

    /**
     * getNextRequiredPage
     * @param currentPage {string}
     * @param conditions {*}
     * @returns {*}
     */
    this.getNextRequiredPage = function (currentPage, conditions) {
        if (!conditions) {
            return null;
        }

        return pageRequirements.getNextRequiredPage(currentPage, conditions);
    };

    /**
     * executeCurrentPageRequirements
     * @returns {boolean}
     */
    this.executeCurrentPageRequirements = function (conditions) {
        let currentPage = self.getCurrentPage();
        return self.executePageRequirements(currentPage, conditions);
    };

    /**
     * executePageRequirements
     * @returns {boolean}
     */
    this.executePageRequirements = function (page, conditions) {
        let requiredPage = self.getNextRequiredPage(page, conditions);
        let currentPage = self.getCurrentPage();

        if (requiredPage == currentPage) {
            return false;
        }

        if (requiredPage) {
            let query = self.getQuery();
            requiredPage = requiredPage + query;
            //console.log('Page requirements found for page:' + page + ', redirecting too:' + requiredPage);
            self.silentNavigate(requiredPage);
            return true;
        }

        //console.log('No page requirements found for page:' + page);
        return false;
    };

    /**
     *
     * @param page
     */
    this.navigate = function (page) {
        //This setTimeout prevents an infinite digest error in IE11 when continuing from address page
        setTimeout(
            function () {
                $window.location.href = page;
            }, 1
        );
    };

    /**
     * silentNavigate
     * @param page
     */
    this.silentNavigate = function (page) {
        //This setTimeout prevents an infinite digest error in IE11 when continuing from the cart page
        setTimeout(
            function () {
                $window.location.replace(page);
            }, 1
        );
    };
};

/**
 * conditionalNavigation
 */
angular.module('checkout').factory(
    'conditionalNavigation',
    [
        '$window',
        'pageRequirements',
        function ($window,
                  pageRequirements) {
            return new CheckoutConditionalNavigation(
                $window,
                pageRequirements,
                '/secure/checkout/v1#/checkout/cart'
            );
        },
    ]
);
